/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, cap: NonNullable<unknown> }} Usage_Overage_Used_Of_CapInputs */



/**
* | output |
* | --- |
* | "Overage used: {used} of {cap} this period" |
*
* @param {Usage_Overage_Used_Of_CapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_used_of_cap = /** @type {((inputs: Usage_Overage_Used_Of_CapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Used_Of_CapInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Überschuss verbraucht: ${i?.used} von ${i?.cap} in diesem Zeitraum`)
	return /** @type {LocalizedString} */ (`Overage used: ${i?.used} of ${i?.cap} this period`)
});